import React from 'react'
import PropTypes from 'prop-types';
import moment from 'moment'

import { Button, DropdownButton, MenuItem } from 'react-bootstrap'
import { ListItem } from '~/views'

import style from './style.css'

export default class SystemItem extends React.Component {
  
  static VIEW_DEVICES_EVENT = 'viewDevices';

  static CONTACTS_EVENT = 'pause';

  static TRANSFER_EVENT = 'transferSystem';

  static REMOVE_EVENT = 'removeSystem';
  static SHOW_UI_EVENT = 'showMoltenUI';

  static propTypes = {
    item : PropTypes.object.isRequired,
    onEvent : PropTypes.func,
    selected : PropTypes.bool
  }

  onEvent( event ) {
    if ( this.props.onEvent ) { 
      this.props.onEvent( event, this.props.item );
    }
  }

  render() {
    const { item : system, hideNavButtons } = this.props;
    return (
      <ListItem className={style.systemItem} 
        onEvent={this.props.onEvent}
        item={system}
        selected={this.props.selected}
        title={system.name}
        subtitle={moment( system.lastModified ).fromNow()}
        leftView={this.renderLeft( system )}
        rightView={this.renderRight( system, hideNavButtons )} />
    )
  }

  renderLeft() {
    return null;
  }

  renderRight( system, hideNavButtons ) {

    return (
      <div>
        <Button bsStyle="link"
          bsSize="large"
          onClick={() => { this.onEvent( SystemItem.SHOW_UI_EVENT ) }}> 
          <img className={style.moltenImage} src="/assets/images/lev-build.png" alt="molten" />

        </Button>
        
        {hideNavButtons !== true && (
          <Button bsStyle="link"
            bsSize="large"
            className={style.deviceButton} 
            onClick={() => { this.onEvent( SystemItem.VIEW_DEVICES_EVENT ) }}> 
            <i className="fa fa-microchip" />
          </Button>
        )}
        {hideNavButtons !== true && (
          <Button bsStyle="link"
            bsSize="large"
            className={style.pauseSystem} 
            onClick={() => { this.onEvent( SystemItem.CONTACTS_EVENT ) }}> 
            <i className="fa fa-users" />
          </Button>
        )}

        <DropdownButton pullRight bsStyle="link" title={<i className="fa fa-fw fa-gear" />} key={system.id} id={`options-${system.id}`}>
          {/*
          <MenuItem bsStyle="link" bsSize="large" className={style.restartTransponders} 
             onClick={()=>{this.onEvent( SystemItem.RESTART_TRANSPONDERS )}} > 
            <i className="fa fa-refresh fa-fw"></i> Restart Transponders
          </MenuItem>
          <MenuItem bsStyle="link" bsSize="large" className={style.pause} 
             onClick={()=>{this.onEvent( SystemItem.TRANSFER_EVENT )}} > 
            <i className="fa fa-paper-plane-o fa-fw"></i> Transfer
          </MenuItem>
          <MenuItem divider />
        */}
          <MenuItem bsStyle="link"
            bsSize="large"
            className={style.pause} 
            onClick={() => { this.onEvent( SystemItem.REMOVE_EVENT ) }}> 
            <i className="fa fa-times-circle fa-fw" />
            {' '}
            Remove
          </MenuItem>
        </DropdownButton>

      </div>
    )
  }

}
